import { render } from "./QuickCart.vue?vue&type=template&id=2c6e3594"
import script from "./QuickCart.vue?vue&type=script&lang=js"
export * from "./QuickCart.vue?vue&type=script&lang=js"

import "./QuickCart.vue?vue&type=style&index=0&id=2c6e3594&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__